<template>
    <section class="appointment-calendar">
        <header class="appointment-calendar__weekdays">
            <h5 v-for="(weekday, index) in weekDays" :key="index" class="appointment-calendar__weekday">
                {{ weekday }}
            </h5>
        </header>

        <ol class="appointment-calendar__days availability-month-calendar">
            <li v-for="(day, index) in monthDays" :key="index" class="appointment-calendar__day">
                <month-calendar-day
                    v-if="day"
                    :year="year"
                    :month="month"
                    :day="day"
                    :physician="physician"
                    :practice="practice"
                    :slots="getSlots(day)"
                    :slotsCount="getSlotsCount(day)"
                    :referralsCount="getReferralsCount(day)"
                    :showCancelled="showCancelled"
                    @emitEvent="emitEvent($event)"
                ></month-calendar-day>
            </li>
        </ol>
    </section>
</template>

<script>
    import dayjs from 'dayjs'
    import CalendarMixin from 'mixins/CalendarMixin'
    import MonthCalendarDay from './AvailabilityMonthCalendarDay'
    import ReferralStatusEnum from '../../../enums/ReferralStatusEnum'

    export default {
        mixins: [CalendarMixin],

        components: {
            MonthCalendarDay,
        },

        props: {
            dates: { type: Object, required: true },
            physician: { type: Object, required: true },
            practice: { type: Object, required: true },
            showCancelled: { type: Boolean, required: true },
        },

        methods: {
            getSlots(day) {
                const date = dayjs().year(this.year).month(this.month).date(day).startOf('day')
                const slots = this.dates[dayjs().year(this.year).month(this.month).date(day).startOf('day').format()] || []
                if (slots.length > 0 && date.isBefore(dayjs(), 'date')) {
                    return slots.filter((slot) => slot.referral)
                }
                return slots
            },

            getSlotsCount(day) {
                return this.getSlots(day).filter((slot) => !slot.referral).length
            },

            getReferralsCount(day) {
                return this.getSlots(day).filter(
                    (slot) =>
                        slot.referral &&
                        slot.referral.status !== ReferralStatusEnum.NO_SHOW &&
                        slot.referral.status !== ReferralStatusEnum.CANCELLED,
                ).length
            },
        },
    }
</script>
